import { L10n } from '@syncfusion/ej2-base';
/**
 * Base class for ribbon groups with common functionality
 * @private
 */
export class RibbonGroupBase {
    /**
     * Constructor for RibbonGroupBase
     * @param {DocumentEditorContainer} container - DocumentEditorContainer instance
     */
    constructor(container) {
        this.container = container;
        this.isRtl = this.container.enableRtl || false;
        this.localObj = new L10n('documenteditorcontainer', this.container.defaultLocale, this.container.locale);
        this.ribbonId = this.container.element.id + '_ribbon';
    }
    /**
     * Gets the DocumentEditor from container
     * @returns {DocumentEditor} - DocumentEditor instance
     */
    get documentEditor() {
        return this.container.documentEditor;
    }
    /**
     * Default implementation for updating selection
     * @returns {void}
     * @private
     */
    updateSelection() {
        // Default implementation - can be overridden by derived classes
    }
    /**
     * Default implementation for wiring events
     * @returns {void}
     * @private
     */
    wireEvents() {
        // Default implementation - can be overridden by derived classes
    }
    /**
     * Default implementation for destroying event handlers
     * @returns {void}
     * @private
     */
    destroy() {
        // Default implementation - can be overridden by derived classes
    }
}
